<template>
	<div
		v-editable="blok"
		class="sb-columns grid"
		:class="`${blok.items_in_row || 'md:grid-cols-3 gap-12'} ${blok.space_between || ''} ${blok.full_width ? 'full-bleed' : ''}`"
	>
		<StoryblokComponent
			v-for="feature in blok.content"
			:key="feature._uid"
			:blok="feature"
			:extra-classes="getExtraClasses(feature.component.toLowerCase())"
		/>
	</div>
</template>

<script setup lang="ts">
// `sb-columns` is a styling hook (styled in promix).
import type { BlokColumns } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokColumns;
	isAdditionalStyles?: boolean;
}

const { blok, isAdditionalStyles } = defineProps<Props>();

const getExtraClasses = (component: string): string | null => {
	if (component === "image") {
		return "w-full";
	}

	if (component === "feature" && isAdditionalStyles) {
		return "!flex-none";
	}

	return null;
};
</script>
